"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPopoverStyles = void 0;
const Utils_1 = require("../../../utils/Utils");
exports.getPopoverStyles = (0, Utils_1.createStyleSheet)(() => ({
    container: {
        position: 'relative',
        display: 'inline-block',
    },
    fullWidth: {
        display: 'block',
        width: '100%',
    },
    panel: {
        position: 'absolute',
        top: '100%',
        left: '0',
        zIndex: 1050,
    },
}), { name: 'Blueprint-Popover' });
